export const DependentTypeLabelsEnum = {
  spouse: 'Cônjuge',
  domestic_partner: 'Companheiro(a)',
  child: 'Filho(a)',
  stepchild: 'Enteado(a)',
  sibling: 'Irmão(ã)',
  grandchild: 'Neto(a)',
  greatgrandchild: 'Bisneto(a)',
  parent: 'Pai/Mãe',
  grandparent: 'Avô/Avó',
  greatgrandparent: 'Bisavô/Bisavó',
  judicially_guarded_minor: 'Menor sob guarda judicial',
  incapacitated_person: 'Pessoa incapaz',
  ex_spouse: 'Ex-cônjuge',
} as const

export type DependentType = keyof typeof DependentTypeLabelsEnum

export type Dependent = {
  id: number
  key: string
  name: string
  tax_id: string
  birthdate?: string
  type: DependentType
  irrf_deduction: boolean
}

export type DependentPayload = Partial<Omit<Dependent, 'id' | 'key'>>
